import type { EditTarget, LayoutBlock } from '@web-studio/shared-schemas';
import { SiteSocialLinks } from '../shared/SiteSocialLinks';

interface FooterSocialLinksProps {
  content: LayoutBlock['content'];
  locale: string;
  editable?: boolean;
  activeEditTarget?: EditTarget | null;
  className?: string;
  showHeading?: boolean;
}

/** Footer-surface social row — Local Presence URLs via hydrated content keys. */
export function FooterSocialLinks(props: FooterSocialLinksProps) {
  return <SiteSocialLinks {...props} surface="footer" />;
}
